import React from 'react';
import { connect } from 'react-redux';
import Breadcrumbs from '../../../shared/components/breadcrumbs';
import {
  addBreadcrumbT,
  deleteBreadcrumbsT,
  deleteBreadcrumbTitleT,
  setBreadcrumbTitleT
} from "../../../../state/actions/shared/breadcrumbs";

const BreadcrumbsRedux = (props) => (
  <Breadcrumbs
    entityType="guide"
    searchEntities={['landing_page']}
    {...props}
  />
);

const mapStateToProps = (state, ownProps) => {
  const {guideId:entityId} = ownProps;
  const guideEntities = state.guides.guide;
  const {editor} = guideEntities;
  const currentGuide = editor[entityId];
  const { breadcrumb, breadcrumbTitle, title, updateId } = currentGuide;
  return {
    breadcrumb,
    breadcrumbTitle,
    entityId,
    entityTitle: title,
    entityUpdateId: updateId,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const {guideId:id} = ownProps;
  return {
    onDeleteBreadcrumb: () => dispatch(deleteBreadcrumbsT('guide', id)),
    onDeleteBreadcrumbTitle: () => dispatch(deleteBreadcrumbTitleT('guide', id)),
    onSelectBreadcrumb: (breadcrumb) => dispatch(addBreadcrumbT('guide', breadcrumb, id)),
    onSetBreadcrumbTitle: (breadcrumbTitle) => dispatch(setBreadcrumbTitleT('guide', breadcrumbTitle, id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbsRedux);
